import { render } from "./CalculLitteral.vue?vue&type=template&id=06fa40eb&scoped=true"
import script from "./CalculLitteral.vue?vue&type=script&lang=js"
export * from "./CalculLitteral.vue?vue&type=script&lang=js"

import "./CalculLitteral.vue?vue&type=style&index=0&id=06fa40eb&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fa40eb"]])

export default __exports__